/**
 * HOS API
 *
 *
 * OpenAPI spec version: 1.0
 * Contact: info@bayinteractive.com
 *
 */
import {Injectable, Injector} from "@angular/core";
import {HosBaseService} from "./hos-base.service";

import {HttpResponse, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import { map } from 'rxjs/operators';
import "../rxjs-operators";
import {AppConstants} from "../../app.constants";
import {PlayTokenWrapper} from "../model/PlayTokenWrapper";

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class MailchimpService extends HosBaseService {


  constructor(injector: Injector) {
     super(injector);
   }

  /**
   * Ping
   *
   * @param itemType The item type
   * @param itemId The item id
   * @param streamCurrentPosition The current stream position
   * @param streamPlayedSecondsSinceLastCall The elapsed seconds since last call
   * @param playToken The play token
   */
  public subscribe(email: string, extraHttpRequestParams?: any): Observable<{}> {
    return this.subscribeWithHttpInfo(email, extraHttpRequestParams)
      .pipe(
        map((response) => {
          if (response.status === 204 || response.status === 200) {
            return undefined;
          } else {
            return response.body;
          }
        })
      );
  }

  public subscribeWithHttpInfo(email: string, extraHttpRequestParams?: any): Observable<HttpResponse<Object>> {
    const path = this.getBasePath() + `/mailchimp/subscribe`;

    let queryParameters = new HttpParams();
    let headers = this.getDefaultHeaders();

    // verify required parameter 'itemType' is not null or undefined
    if (email === null || email === undefined) {
      throw new Error('Required parameter email was null or undefined when calling ping.');
    }

    // to determine the Content-Type header
    let consumes: string[] = [];
    let canConsumeForm = this.canConsumeForm(consumes);
    let useForm = false;
    let formParams = new HttpParams();

    // to determine the Accept header
    let produces: string[] = [
      'application/json'
    ];

    /*if (itemType !== undefined) {
      formParams = formParams.set('itemType', itemType);
    }*/


    let requestOptions = {
      headers: headers,
      body: email,
      params: queryParameters
    };

    // https://github.com/swagger-api/swagger-codegen/issues/4037
    if (extraHttpRequestParams) {
      requestOptions = this.extendObj(requestOptions, extraHttpRequestParams);
    }

    return this.executeHttpRequest(AppConstants.RequestMethods.POST, path, requestOptions);
  }

}
